import React, { useContext, useLayoutEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { accountStatusContext } from "../../../../Diathrive/src/contexts/AccountStatusContext";
import CoachOnBoardingExperienceWeb from "./CoachOnBoardingExperienceWeb";
import AdvisorsDashboard from "./AdvisorsDashboard";
import AppointmentTypeSelect from "./AppointmentTypeSelect";
import DateTimeSelectWeb from "./DateTimeSelectWeb";
import ConfirmAppointmentWeb from "./ConfirmAppointmentWeb";

const Advising = () => {
  const { setHeaderName } = useOutletContext();
  const asc = useContext(accountStatusContext);
  const [view, setView] = useState("list");
  const [selectedEventType, setSelectedEventType] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);

  useLayoutEffect(() => {
    if (setHeaderName) setHeaderName("Advising");
  }, [setHeaderName]);

  if (!asc.isOnboarded) {
    return <CoachOnBoardingExperienceWeb />;
  }

  if (view === "type-select") {
    return (
      <AppointmentTypeSelect
        onNext={(eventType) => {
          setSelectedEventType(eventType);
          setView("date-time");
        }}
        onCancel={() => setView("list")}
      />
    );
  }

  if (view === "date-time") {
    return (
      <DateTimeSelectWeb
        eventType={selectedEventType}
        onNext={(time) => {
          setSelectedTime(time);
          setView("confirm");
        }}
        onBack={() => setView("type-select")}
      />
    );
  }

  if (view === "confirm") {
    return (
      <ConfirmAppointmentWeb
        eventType={selectedEventType}
        selectedTime={selectedTime}
        onConfirmed={() => setView("list")}
        onBack={() => setView("date-time")}
      />
    );
  }

  return <AdvisorsDashboard onSchedule={() => setView("type-select")} />;
};

export default Advising;
